import { Box, Skeleton } from "@mui/material";
import { useParams, useHistory } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadAction, loadAlert, loadFavAlert } from "redux/reducers/top";
import { makeStyles } from "@mui/styles";
import { rem, renderNoti } from "assets/js/common";
import axios from "axios";
import StampWrap from "components/stamp/stamp-wrap";
import AlertConfirm from "components/ui/alert-confirm";
import AlertComplete from "components/ui/alert-complete";
import { loadMembershipAction } from "redux/reducers/membership";
import InnerHTML from "dangerously-set-html-content";
import { Cookies } from "react-cookie";
import { setAppData } from "assets/js/apphandle";

const useStyles = makeStyles((theme) => ({
  MembershipDetail: {
    "& .notice": {
      padding: `${rem(30)} !important`,
    },
    "& .secession": {
      padding: `${rem(20)} ${rem(30)} ${rem(60)} ${rem(30)}`,
      borderTop: `1px solid #F6F6F6`,
    },
  },
}));

export default function Membership(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();

  let { cd } = useParams();

  let cookies = new Cookies();

  let favInfo = cookies.get("favInfo");

  const storeCode = favInfo
    ? favInfo.visibleTp === "1"
      ? favInfo.favMt
      : favInfo.favMk
    : "";
  const { alertOpen, favAlertOpen } = useSelector((state) => state.top);
  const { membership, loading } = useSelector((state) => state.membership);

  const [open, setOpen] = useState(false);
  const [alertMode, setAlertMode] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0);

    dispatch(
      loadMembershipAction({
        cd: cd,
        storeCode: storeCode || "ALL",
      })
    );

    cookies.remove("referrer", { path: "/" });

    return ()=> {
      setAppData();
    }
  }, []);

  window.appBackKeyHandle = () => {
    let loginModalEl = document.getElementById("loginModal");
    let alertModalEl = document.getElementById("alertModal");

    if (loginModalEl && loginModalEl.style.display == "block") {
      loginModalEl.style.display = "none";
    } else if (alertModalEl && alertModalEl.style.display == "block") {
      alertModalEl.style.display = "none";
    } else if (open) {
      setOpen(false);
      if (alertMode != "ask-secession") {
        history.goBack();
      }
    } else if (alertOpen) {
      dispatch(loadAlert(false));
    } else if (favAlertOpen) {
      dispatch(loadFavAlert(false));
    } else {
      history.goBack();
    }
  };

  useEffect(() => {
    if (membership) {
      dispatch(loadAction({ back: true, title: membership.nm, menu: false }));
    }
  }, [membership]);

  const handleAlertMode = (mode) => {
    setAlertMode(mode);
    setOpen(true);
  };

  const handleAlertClose = () => {
    setOpen(false);
  };

  const onLeave = () => {
    setOpen(false);

    axios
      .post("/api/eh/membership-club/leave", {
        cd: membership.cd,
      })
      .then((res) => {
        handleAlertMode("secession-complete");
      });
  };

  const callback = () => {
    handleAlertMode("secession-complete");
  };

  const goLogin = () => {
    var cookieExpires = new Date();
    cookieExpires.setDate(cookieExpires.getDate() + 180);
    setCookie("referrer", window.location.pathname, cookieExpires, "/");
    // window.location.href = "/login?edit=Y";
    history.push({
      pathname: "/login",
      state: {
        from: {
          pathname: location.pathname,
        },
      },
    });
  };

  const onConfirm = () => {
    var layerModal = document.getElementById("alertModal");
    var layerBody = document.getElementsByTagName("body")[0];
    layerModal.style.display = "none";
    layerBody.style.overflow = "visible";

    dispatch(
      loadMembershipAction({
        cd: cd,
        storeCode: storeCode || "ALL",
      })
    );
  };

  if (loading) {
    return <Skeleton width={"100%"} variant="rectangular" height={1000} />;
  }

  return (
    <>
      <div className={classes.MembershipDetail}>
        {membership && (
          <>
            {membership.joinYn == "Y" ? (
              <>
                <InnerHTML html={membership.topCont} />
                {membership.tp == 2 && (
                  <div
                    style={{
                      backgroundImage: `${"url(" + membership.bgImgUrl + ")"}`,
                      backgroundSize: "100% auto",
                      backgroundRepeat: "no-repeat",
                    }}
                  >
                    <StampWrap detailData={membership} bgYn="Y" />
                  </div>
                )}
                <InnerHTML html={membership.botCont} />
                {membership.joinNoti && (
                  <Box className="notice is-bottom" p={6}>
                    <p className="title">
                      <i className="ico-noti" />
                      유의사항
                    </p>
                    <ul className="list list-dot color-info font-14">
                      {renderNoti(membership.joinNoti).map((item, i) => (
                        <li key={i}>{item}</li>
                      ))}
                    </ul>
                  </Box>
                )}
                <Box className="secession">
                  <div
                    className="btn-link color-info font-14"
                    onClick={() => {
                      handleAlertMode("ask-secession");
                    }}
                  >
                    클럽탈퇴
                    <i className="ico-go-grey" />
                  </div>
                </Box>
              </>
            ) : (
              <>
                <div
                  dangerouslySetInnerHTML={{
                    __html: membership.cont,
                  }}
                />
                {membership.noti && (
                  <Box className="notice is-bottom" p={6}>
                    <p className="title">
                      <i className="ico-noti" />
                      유의사항
                    </p>
                    <ul className="list list-dot color-info font-14">
                      {renderNoti(membership.noti).map((item, i) => (
                        <li key={i}>{item}</li>
                      ))}
                    </ul>
                  </Box>
                )}
              </>
            )}
          </>
        )}

        {alertMode == "ask-secession" ? (
          <AlertConfirm
            open={open}
            handleAlertClose={handleAlertClose}
            text="클럽을 탈퇴하시겠습니까?"
            action={onLeave}
          />
        ) : (
          <AlertComplete
            open={open}
            handleAlertClose={handleAlertClose}
            text={`정상적으로 ${membership.nm}을(를) 탈퇴했습니다.`}
            action={() => {
              handleAlertClose();
              history.goBack();
            }}
          />
        )}
      </div>

      {/* 에디터 알림 팝업 */}
      <div id="loginModal" className="layerPop">
        <div className="dialog">
          <h2>알림</h2>
          <div className="dialog-content">
            로그인이 필요한 서비스입니다.
            <br />
            로그인 하시겠습니까?
          </div>
          <div className="dialog-btn">
            <button className="btn-cancel">취소</button>
            <button className="btn-confirm" onClick={goLogin}>
              확인
            </button>
          </div>
        </div>
      </div>

      <div id="alertModal" className="layerPop">
        <div className="dialog">
          <h2>알림</h2>
          <div id="alertCont" className="dialog-content" />
          <div className="dialog-btn">
            <button className="btn-confirm" onClick={onConfirm}>
              확인
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
